import { render, staticRenderFns } from "./BellEditDisplaySettings.vue?vue&type=template&id=478e6a8c&scoped=true"
import script from "./BellEditDisplaySettings.vue?vue&type=script&lang=js"
export * from "./BellEditDisplaySettings.vue?vue&type=script&lang=js"
import style0 from "./BellEditDisplaySettings.vue?vue&type=style&index=0&id=478e6a8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478e6a8c",
  null
  
)

export default component.exports